import { JetView } from "webix-jet";

export default class CredentialsWinView extends JetView {
	config() {
		const _ = this.app.getService("locale")._;
		return {
			view: "window",
			modal: true,
			move: true,
			width: 300,
			height: 300,
			head: {
				view: "toolbar",
				padding: { left: 20, right: 9 },
				borderless: true,
				elements: [
					{ view: "label", label: _("New password") },
					{
						view: "icon",
						icon: "wxi-close",
						hotkey: "esc",
						click: () => this.getRoot().close(),
					},
				],
			},
			position: "center",
			body: {
				view: "form",
				localId: "form",
				padding: { top: 20, left: 20, right: 20, bottom: 20 },
				margin: 2,
				elements: [
					{
						view: "button",
						label: _("Generate password"),
						click: () => this.GeneratePassword(),
					},
					{
						borderless: true,
						height: 20,
						cols: [
							{},
							{
								template: "<div class='webix_um_divider_line'/>",
								css: "webix_um_divider",
								borderless: true,
								width: 40,
							},
							{},
						],
					},
					{
						margin: 10,
						rows: [
							{
								labelPosition: "top",
								css: "webix_um_passw_label",
								label: _("Enter password"),
								view: "text",
								name: "password",
								validate: "isNotEmpty",
								type: "password",
							},
							{
								view: "button",
								css: "webix_primary",
								label: _("Reset password"),
								click: () => this.ResetPassword(),
							},
						],
					},
				],
			},
			on: {
				onShow() {
					const input = this.getBody().elements.password.getInputNode();
					input.focus();
				},
			},
		};
	}
	Show(id) {
		this.getRoot().show();
		this.ID = this.getParam("id", true) * 1;
		this.credID = id;
	}

	GeneratePassword() {
		this.app.getService("backend").resetPassword(this.ID, { id: this.credID });
		this.getRoot().close();
	}
	ResetPassword() {
		if (this.$$("form").validate()) {
			const record = this.$$("form").getValues().password;
			this.app
				.getService("backend")
				.resetPassword(this.ID, { id: this.credID, record });
			this.getRoot().close();
		}
	}
}
